import AddressCollectionWrapper from 'features/reactivation/screens/Address/AddressCollectionWrapper';
import React from 'react';

export default function ReactivationAddressPage() {
  return <AddressCollectionWrapper />;
}
